export const SEARCH_INSURANCE_POLICY_ASYNC = 'SEARCH_INSURANCE_POLICY_ASYNC';
export const SEARCH_INSURANCE_POLICY_SUCCESS = 'SEARCH_INSURANCE_POLICY_SUCCESS';
export const CREATE_INSURANCE_POLICY_ASYNC = 'CREATE_INSURANCE_POLICY_ASYNC';
export const UPDATE_INSURANCE_POLICY_ASYNC = 'UPDATE_INSURANCE_POLICY_ASYNC';
export const MAKE_ACTIVE_INSURANCE_POLICY_ASYNC = 'MAKE_ACTIVE_INSURANCE_POLICY_ASYNC';
export const MAKE_INACTIVE_INSURANCE_POLICY_ASYNC = 'MAKE_INACTIVE_INSURANCE_POLICY_ASYNC';
export const OPEN_FORM_CREATE_INSURANCE_POLICY = 'OPEN_FORM_CREATE_INSURANCE_POLICY';
export const CLOSE_FORM_CREATE_INSURANCE_POLICY = 'CLOSE_FORM_CREATE_INSURANCE_POLICY';
export const GET_INSURANCE_POLICY_BY_ID_ASYNC = 'GET_INSURANCE_POLICY_BY_ID_ASYNC';
export const GET_INSURANCE_POLICY_BY_ID_SUCCESS = 'GET_INSURANCE_POLICY_BY_ID_SUCCESS';
export const ADD_EDIT_INSURANCE_POLICY_ERROR = 'ADD_EDIT_INSURANCE_POLICY_ERROR';
export const RESET_INSURANCE_POLICY = 'RESET_INSURANCE_POLICY';
export const GET_SELECT_LIST_INSURANCE_POLICY_ASYNC = 'GET_SELECT_LIST_INSURANCE_POLICY_ASYNC';
export const GET_SELECT_LIST_INSURANCE_POLICY_SUCCESS = 'GET_SELECT_LIST_INSURANCE_POLICY_SUCCESS';




// WEBPACK FOOTER //
// ./src/Insurance/constants.js